import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const dataReviewApi = createApi({
  baseQuery,
  reducerPath: 'dataReviewApi',
  endpoints: builder => ({
    getDataReviewData: builder.query<any, any>({
      query: ({ site_id, study_id, country, data, application = 'CTMS', from = -1, size = -1 }) => ({
        url: `${formatString(endPoints.DataReview.getAll, {
          key: urlKeys.study_id,
          value: study_id
        })}?${country !== null ? `country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT${from > -1 ? `&from=${from}` : ''}${
          size > -1 ? `&size=${size}` : ''
        }`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getDataReviewVisits: builder.query<any, any>({
      query: ({ study_id }) => ({
        url: formatString(endPoints.DataReview.getAllVisits, {
          key: urlKeys.study_id,
          value: study_id
        }),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getDataReviewCRFSummaryData: builder.query<any, any>({
      query: ({ study_id, subject_id, visit }) => ({
        url: `${formatString(
          endPoints.DataReview.crfSummarySelect,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          { key: urlKeys.subject_id, value: subject_id }
        )}?visit=${visit}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getDataReviewCRFs: builder.query<any, any>({
      query: ({ study_id }) => ({
        url: formatString(endPoints.DataReview.getDataReviewcrfs, {
          key: urlKeys.study_id,
          value: study_id
        }),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getCalendarVisitsData: builder.query<any, any>({
      query: ({ site_id, study_id, country, data, application = 'CTMS' }) => ({
        url: `${formatString(endPoints.calendarVisits.getAll, {
          key: urlKeys.study_id,
          value: study_id
        })}?${country !== null ? `country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${application}&application_section=CONDUCT`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
  })
});

export const {
  useLazyGetDataReviewDataQuery,
  useLazyGetDataReviewVisitsQuery,
  useLazyGetDataReviewCRFSummaryDataQuery,
  useLazyGetDataReviewCRFsQuery,
  useLazyGetCalendarVisitsDataQuery
} = dataReviewApi;
